import { render, staticRenderFns } from "./matrixBenchmarking.vue?vue&type=template&id=5a9f64c4&scoped=true"
import script from "./matrixBenchmarking.vue?vue&type=script&lang=js"
export * from "./matrixBenchmarking.vue?vue&type=script&lang=js"
import style0 from "./matrixBenchmarking.vue?vue&type=style&index=0&id=5a9f64c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9f64c4",
  null
  
)

export default component.exports